import React, { memo, useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import Textfield from '../../components/TextFields/index';
import Button from '../../components/Button/index';
import styles from './styles';

export interface CustomMortgageSectionProps {
  onClick: (e: string) => void;
}

function CustomMortgageSection({ onClick }: CustomMortgageSectionProps) {
  const [interestRate, setInterestRate] = useState(5.5);

  return (
    <Grid container sx={styles.container}>
      <Grid item md={12} height="100%" width="100%">
        <Typography sx={styles.title}>
          Set your mortgage repayments across Foxtons.co.uk to your own custom
          rate:
        </Typography>
        <Typography sx={styles.subTitle}>
          Enter your own interest rate:
        </Typography>
        <Textfield
          sx={styles.textField}
          value={interestRate}
          onChange={(e) => setInterestRate(e?.target?.value)}
        />
        <Box sx={styles.buttonContainer}>
          <Button
            variant="primary-dark"
            fullWidth
            onClick={() => onClick(interestRate)}
          >
            Calculate
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default memo(CustomMortgageSection);
